import React from 'react';
import { FooterContainer, FooterText } from './FooterStyle';

const Footer = () => {
    return (
        <FooterContainer>
            <FooterText>
                ©Copyright. All rights received by @Bayezid.
            </FooterText>
        </FooterContainer>
    );
};

export default Footer;